import { Component, inject } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-overlay',
  standalone: true, // 🔥 IMPORTANT
  imports: [CommonModule], // 🔥 POUR async + ngIf
  templateUrl: './loading-overlay.html',
  styleUrls: ['./loading-overlay.scss']

})
export class LoadingOverlayComponent {
  private loadingService = inject(LoadingService);
  public loading$: Observable<boolean>=this.loadingService.loading$;


}
